/**
 * Wrapper type used to circumvent ESM modules circular dependency issue
 * caused by reflection metadata saving the type of the property.
 * Needed for NestJs forwardRef utility. Taken from https://www.reddit.com/r/nestjs/comments/15yb1ek/comment/kc7c2zt/?utm_source=share&utm_medium=web3x&utm_name=web3xcss&utm_term=1&utm_content=share_button
 */
export type WrapperType<T> = T;
